<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">

        <!-- PC Task -->
        <div class="d-flex justify-content-between pb-3"
          [ngStyle]="{'flex-direction': isMobile ? 'column' : 'row', 'align-items': isMobile ? 'flex-start' : 'center'}"
          *ngIf="!bulkInvoicing && !isMobile">
          <span *ngIf="!bulkInvoicing">
            <h2 class="text-purple-manax m-0 title-section" [ngClass]="{'pl-3': !isMobile}">Trabajos</h2>
          </span>
          <span *ngIf="!bulkInvoicing">
            <button mat-raised-button type="button" class="btn btn-outline py-1 px-3 mx-0" (click)="openTasksByList()"
              style="height: 30px !important; border-radius: 6px 0px 0px 6px !important;">
              <i class="material-icons">list</i>&nbsp;<span class="d-none d-sm-inline">Listado</span>
            </button>
            <button mat-raised-button type="button" class="btn btn-outline-manax py-1 px-3 mx-0"
              style="height: 30px !important; border-radius: 0px 0px 0px 0px !important;">
              <i class="material-icons">table_chart</i>&nbsp;<span class="d-none d-sm-inline">Histórico</span>
            </button>
            <button mat-raised-button type="button" class="btn btn-outline py-1 px-3 mx-0" (click)="openTasksByStatus()"
              style="height: 30px !important; border-radius: 0px 6px 6px 0px !important;">
              <i class="material-icons">table_chart</i>&nbsp;<span class="d-none d-sm-inline">Tablero</span>
            </button>
          </span>
          <span class="pt-1 pb-1" *ngIf="!bulkInvoicing" [ngClass]="{'pr-3': !isMobile}">
            <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openNewTaskModal('SCHEDULED')">
              <i class="material-icons">add</i> Nuevo Trabajo
            </button>
            <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2 ml-2">
              <i class="material-icons align-middle">play_circle</i> Tutorial
            </button>
          </span>
        </div>

        <!-- Mobile Task-->
        <div *ngIf="!bulkInvoicing && isMobile" class="pb-5">
          <div class="row d-flex align-items-center justify-content-between px-3 py-2">
            <span *ngIf="!bulkInvoicing" class="pull-left">
              <h2 class="text-purple-manax m-0 title-section">Trabajos</h2>
            </span>
            <span class="pull-right pt-1 pb-1" *ngIf="!bulkInvoicing">
              <button mat-raised-button type="button" class="btn btn-manax p-2" [matMenuTriggerFor]="menu"
                (click)="$event.stopPropagation()">
                <i class="material-icons">add</i>
              </button>
              <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2">
                <i class="material-icons align-middle">play_circle</i>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openNewTaskModal('OPEN')">
                  <span><i class="material-icons align-middle">move_to_inbox</i> Solicitud de Trabajo</span>
                </button>
                <button mat-menu-item (click)="openNewTaskModal('SCHEDULED')">
                  <span><i class="material-icons align-middle">business_center</i> Trabajo Programado</span>
                </button>
              </mat-menu>
            </span>
          </div>

          <div class="row d-flex align-items-center justify-content-center px-3 py-2">
            <span *ngIf="!bulkInvoicing" style="align-self: center !important;">
              <button mat-raised-button type="button" class="btn btn-outline-manax py-1 px-3 mr-0"
                style="height: 30px; border-radius: 6px 0px 0px 6px;">
                <i class="material-icons">list</i>&nbsp;<span>Listado</span>
              </button>
              <button mat-raised-button type="button" class="btn btn-outline py-1 px-3 ml-0"
                (click)="openTasksByStatus()" style="height: 30px; border-radius: 0px 6px 6px 0px;">
                <i class="material-icons">table_chart</i>&nbsp;<span>Tablero</span>
              </button>
            </span>
          </div>
        </div>

        <!-- Bulk -->
        <span class="pull-left" *ngIf="bulkInvoicing">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Generar Facturacion</h2>
          <div class="text-purple-manax" *ngIf="bulkInvoicing" style="width: 100%;">
            <span class="pull-left px-4">
              Indique <b>rango de fechas</b> y <b>cliente</b> para listar trabajos <b>completados</b>.
              Seleccione cuales van a ser incluidos en la factura.
            </span>
          </div>
        </span>
        <div class="text-purple-manax" *ngIf="bulkInvoicing" style="width: 100%;">
          <span class="pull-right pt-1 pb-4 pr-3" *ngIf="selection.some || selection.all">
            <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openCreateBulkInvoicing()">
              <i class="material-icons">paid</i> Generar Factura
            </button>
          </span>
        </div>

        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortTasks($event)" stickyHeader
          stickyFooter>

          <thead class="text-lavuro">
            <tr>

              <!-- PC -->
              <th class="d-none d-md-table-cell p-0 pl-2" width="1%">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" style="height: 90px; position: relative; width: 180x;"
                mat-sort-header="scheduledStart">
                Fecha<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dateStart"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 120px; position: absolute; top: 27px; left: 0px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dateEnd"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 120px; position: absolute; top: 50px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" width="200px"
                style="height: 90px; position: relative; max-width: 1000px;" mat-sort-header="status">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.status" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()" [disabled]="bulkInvoicing"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;">
                  <option [ngValue]="undefined"> - select - </option>
                  <option *ngFor="let key of taskStatusesKeys" [ngValue]="key">{{taskStatuses[key]}}</option>
                </select>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 90px; position: relative;"
                mat-sort-header="title">
                Título<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.title"
                  placeholder="Buscar por título…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top"
                style="height: 90px; position: relative; max-width: 1000px; min-width: 200px;">
                Categoría<br>
                <select class="filter small" [(ngModel)]="filter.filters.category" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 40px; left: 0px;">
                  <option [ngValue]="undefined"> - select - </option>
                  <option *ngFor="let key of categories" [ngValue]="key._id">{{key.name}}</option>
                </select>
              </th>

              <th class="d-none d-md-table-cell align-top" width="1%">
                Total&nbsp;{{curr}}<br>
              </th>

              <!-- Mobile -->
              <!-- <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort] || 'ninguno'}}</span>
                <span class="text-lavuro pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th> -->

              <!-- PC -->
              <th class="d-none d-md-table-cell td-actions text-right p-0" width="1%">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <!--button mat-menu-item (click)="openFilter()">
                          <span>Filtro avanzado</span>
                        </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>

                  <!-- actions -->
                  <!-- 
                        <ng-container>
                          <button mat-menu-item (click)="openBulkDeleteActionTaskConfirm()">
                            <span>Eliminar</span>
                          </button>
                          <button mat-menu-item (click)="openBulkRestoreActionTaskConfirm()">
                            <span>Restaurar</span>
                          </button>
                        </ng-container>
                        -->
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortTasks(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortTasks('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let task of tasks" [class.text-danger]="task.isDeleted"
              class='cursor-pointer' (click)="openTasksModal(task)"><!--task.status?.value == 4 -->

              <!-- PC -->
              <td class="d-none d-md-table-cell p-0 pl-2 align-middle" (click)="$event.stopPropagation();" width="1%">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label" *ngIf="!bulkInvoicing || !task.serviceAgreement">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(task._id)"
                      [checked]="selection.all || selection[task._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell text-left" width="180px">
                <span *ngIf="task.scheduledStart">
                  {{task.scheduledStart | date:'dd/MM/yyyy HH:mm'}}
                  <i class="material-icons inline-icon">pending_actions</i>
                </span>
                <span *ngIf="!(task.scheduledStart)">{{task.createdAt | date:'dd/MM/yyyy'}}</span>
              </td>
              <td class="d-none d-md-table-cell p-1">
                <div class="text-center py-1 status-pill"
                  [ngStyle]="{'background-color': taskStatusColors[task.status || ''] || taskStatusColors.DEFAULT}"
                  [class.text-white]="task.status">
                  {{taskStatuses[task.status || '']}}
                </div>
              </td>
              <!-- <td class="d-none d-md-table-cell">{{taskStatuses[task.status]}}</td> -->
              <td class="d-none d-md-table-cell">{{task.client?.firstname}} {{task.client?.lastname}}</td>
              <td class="d-none d-md-table-cell">{{task.title}}</td>
              <td class="d-none d-md-table-cell">{{task.category?.[0]?.name}}</td>
              <td class="d-none d-md-table-cell text-right" *ngIf="!task.serviceAgreement">{{task.total | number:
                '1.2-2'}}</td>
              <td class="d-none d-md-table-cell text-right" *ngIf="task.serviceAgreement"> - </td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{task.title}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        {{task.client?.firstname}} {{task.client?.lastname}}
                      </div>
                      <div class="row pr-3">
                        {{task.category?.[0]?.name}}
                      </div>
                    </div>
                    <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row mb-2">
                        <div class="text-center"
                          style="border-radius: 15px; font-weight: 600; padding: 5px 20px; color: white; font-size: 13px;"
                          [ngStyle]="{'background-color': taskStatusColors[task.status || ''] || taskStatusColors.DEFAULT}"
                          [class.text-white]="task.status">
                          {{taskStatuses[task.status || '']}}
                        </div>
                      </div>
                      <div class="row pl-3">
                        {{task.scheduledStart | date:'dd/MM'}} de {{task.scheduledStart | date:'HH:mm'}} a
                        {{task.scheduledEnd | date:'HH:mm'}}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0" width="1%">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openTasksModal(task)">
                    <span>Abrir</span>
                  </button>
                  <button mat-menu-item (click)="openTasksModal(task)">
                    <span>Modificar</span>
                  </button>
                  <button mat-menu-item (click)="openDuplicateTaskModal(task)">
                    <span>Duplicar</span>
                  </button>
                  <button mat-menu-item (click)="openExternalRequestModal(task)">
                    <span>Compartir Información</span>
                  </button>
                  <!--<button mat-menu-item (click)="openDeleteTaskConfirm(task, true)" *ngIf="isDev">
                    <span>Hard Delete</span>
                  </button>-->
                  <button mat-menu-item (click)="openDeleteTaskConfirm(task)" *ngIf="!task.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreTaskConfirm(task)" *ngIf="task.isDeleted">
                    <span>Restaurar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ tasks.length }} trabajos</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>